import React, {useEffect, useState} from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

import AddressCard from '../../components/AddressCard';
import WrapperContent from './WrapperContent';
import AppButton from '../../components/AppButton';

import AddressDialog from '../../components/AddressDialog';
import api from '../../services/api';
import {addNotification} from '../../redux/actions/notifications';
import {useDispatch} from 'react-redux';

import Loading from '../../Loading';

const MyAddress = () => {
  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [currentEditAddress, setCurrentEditAdrress] = useState({
    city: {},
    state: {},
    active: false,
  });

  useEffect(() => {
    setLoading(true);
    // noinspection JSIgnoredPromiseFromCall
    fetchAddress();
  }, []);

  const updateMainAddress = async (id) => {
    try {
      await api.addresses.patch(id, {
        main: 'true',
      });
      // noinspection ES6MissingAwait
      fetchAddress();
    } catch (e) {
      dispatch(addNotification(e.message, 'error'));
    }
  };

  const fetchAddress = async () => {
    setLoading(true);
    try {
      const {data} = await api.addresses.find();
      setItems(data);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpenDialog(false);
    setCurrentEditAdrress({city: {}, state: {}, active: false});
    // noinspection JSIgnoredPromiseFromCall
    fetchAddress();
  };

  const deleteAddress = async (id) => {
    try {
      await api.addresses.remove(id);
      dispatch(addNotification('Dirección eliminada', 'success'));
      // noinspection ES6MissingAwait
      fetchAddress();
    } catch (e) {
      dispatch(addNotification(e.message, 'error'));
    }
  };

  const editAddress = (id) => {
    let currentEditAddress = items.find((item) => item.id === id);
    setCurrentEditAdrress({...currentEditAddress, active: true});
    setOpenDialog(true);
  };

  return (
    <WrapperContent>
      <Loading loading={loading} />
      <Box mt={5}>
        <Grid container spacing={5}>
          {items.map((item) => (
            <Grid item xs={12} md={4} key={item.id}>
              <AddressCard
                handleChangeMain={() => updateMainAddress(item.id)}
                deleteAddress={() => deleteAddress(item.id)}
                editAddress={() => editAddress(item.id)}
                item={item}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
      <Box display="flex" justifyContent="flex-end" mt={6} mb={4}>
        <AppButton
          onClick={() => setOpenDialog(true)}
          color="secondary"
          round
          disableElevation
          variant="contained"
        >
          Añadir nueva dirección
        </AppButton>
      </Box>
      <AddressDialog
        currentEditAddress={currentEditAddress}
        handleClose={handleClose}
        open={openDialog}
      />
    </WrapperContent>
  );
};

export default MyAddress;
